/* eslint-disable max-len */
import { INTL_IDS } from './messages';
import { INTL_IDS as PAYMENTS_INTL_IDS } from '../messages';

export const AUTOPAY_ENABLE = 'app/Payments/Autopay/AUTOPAY_ENABLE';
export const AUTOPAY_ENABLE_FAILURE = 'app/Payments/Autopay/AUTOPAY_ENABLE_FAILURE';
export const AUTOPAY_ENABLE_SUCCESS = 'app/Payments/Autopay/AUTOPAY_ENABLE_SUCCESS';
export const AUTOPAY_ENABLE_VALIDATION_FAILURE = 'app/Payments/Autopay/AUTOPAY_ENABLE_VALIDATION_FAILURE';

export const CANCEL = 'app/Payments/Autopay/CANCEL';
export const CANCEL_FAILURE = 'app/Payments/Autopay/CANCEL_FAILURE';
export const CANCEL_SUCCESS = 'app/Payments/Autopay/CANCEL_SUCCESS';

export const CHANGE = 'app/Payments/Autopay/CHANGE';
export const CHANGE_FAILURE = 'app/Payments/Autopay/CHANGE_FAILURE';
export const CHANGE_SUCCESS = 'app/Payments/Autopay/CHANGE_SUCCESS';
export const CHANGE_VALIDATION_FAILURE = 'app/Payments/Autopay/CHANGE_VALIDATION_FAILURE';

export const CHANGE_INPUT = 'app/Payments/Autopay/CHANGE_INPUT';

export const CHANGE_STEP = 'app/Payments/Autopay/CHANGE_STEP';

export const FETCH_STATUS = 'app/Payments/Autopay/FETCH_STATUS';
export const FETCH_STATUS_FAILURE = 'app/Payments/Autopay/FETCH_STATUS_FAILURE';
export const FETCH_STATUS_SUCCESS = 'app/Payments/Autopay/FETCH_STATUS_SUCCESS';

export const RESET_AUTOPAY_STATE = 'app/Payments/Autopay/RESET_AUTOPAY_STATE';

export const RESET_CONFIRMATION = 'app/Payments/Autopay/RESET_CONFIRMATION';

export const RESET_CANCEL_CONFIRMATION = 'app/Payments/Autopay/RESET_CANCEL_CONFIRMATION';

export const RESET_REQUEST_STATUS = 'app/Payments/Autopay/RESET_REQUEST_STATUS';

export const SET_IS_MODAL_OPEN = 'app/Payments/Autopay/SET_IS_MODAL_OPEN';
export const SET_IS_AMOUNT_DRAWER_OPEN = 'app/Payments/Autopay/SET_IS_AMOUNT_DRAWER_OPEN';

export const SET_IS_IN_AUTOPAY_FLOW = 'app/Payments/Autopay/SET_IS_IN_AUTOPAY_FLOW';

export const STOP = 'app/Payments/Autopay/STOP';
export const STOP_FAILURE = 'app/Payments/Autopay/STOP_FAILURE';
export const STOP_SUCCESS = 'app/Payments/Autopay/STOP_SUCCESS';

export const UPDATE_AMOUNT = 'app/Payments/Autopay/UPDATE_AMOUNT';

export const UPDATE_EMAIL_ALERT_SETTING_FAILURE = 'app/Payments/Autopay/UPDATE_EMAIL_ALERT_SETTING_FAILURE';

export const UPDATE_FORM_ERROR = 'app/Payments/Autopay/UPDATE_FORM_ERROR';

// Messages
export const AUTOPAY_MODAL_DICTIONARY = {
  cancel: {
    Change_Requested: {
      label: 'Yes',
      text: 'Are you sure that you want to cancel this pending request? Selecting “Yes” will immediately cancel this request and no changes will be made to your current automatic payment settings.',
      title: 'Cancel request to update automatic payment settings',
    },
    Enable_Requested: {
      buttonText: 'Yes',
      label: 'Yes',
      text: 'Are you sure that you want to cancel this pending request? Selecting “Yes” will immediately cancel this request.',
      title: 'Cancel request to enroll for automatic payments',
    },
    Stop_Requested: {
      label: 'Yes',
      text: 'Are you sure that you want to cancel this pending request? Selecting “Yes” will immediately cancel this request.',
      title: 'Cancel request to unenroll from automatic payments',
    },
  },
  change: {
    label: 'Yes',
    text: `Are you sure that you want to make these updates to your automatic payment settings?\n
    Please note that if this request is submitted less than 10 days prior to your next scheduled draft date, then the change(s) may not take effect with your next scheduled draft date.\n
    If you have any questions, please contact Customer Service at {{customerServicePhoneNumber}} for assistance.`,
    title: 'Update Automatic Payment Settings',
  },
  stop: {
    label: 'Yes',
    text: `Are you sure that you want to unenroll from automatic payments?\n
    Please note that if this request is submitted less than 10 days prior to your next scheduled draft date, then the change may not take effect with your next scheduled draft date.\n
    If you have any questions, please contact Customer Service at {{customerServicePhoneNumber}} for assistance.`,
    title: 'Unenroll from Automatic Payments',
  },
};

export const AUTOPAY_SPLASH_DICTIONARY = {
  buttonLabel: 'Enroll in Automatic Payments',
  headerText: 'Enroll in monthly automatic payments',
  listText: [
    PAYMENTS_INTL_IDS.SPLASHPAGE_AUTOPAY_TEXT_MORTGAGEPAYMENTS,
    PAYMENTS_INTL_IDS.SPLASHPAGE_AUTOPAY_TEXT_ELIMINATESRISKS,
    PAYMENTS_INTL_IDS.SPLASHPAGE_AUTOPAY_TEXT_ABILITYTOREMIT,
    PAYMENTS_INTL_IDS.SPLASHPAGE_AUTOPAY_TEXT_ENVIRONMENTALLYFRIENDLY,
  ],
};

export const CANCEL_AUTOPAY_DICTIONARY = {
  cancel: {
    Change_Requested: {
      buttonText: 'Return to Payments',
      header: 'Good news! Your request to update your automatic payment settings has been canceled',
      text: 'An email will be sent to you confirming that your pending request has been canceled. No changes will be made to your current automatic payment settings.',
    },
    Enable_Requested: {
      buttonText: 'Return to Payments',
      header: 'Good news! Your request to enroll for automatic payments has been canceled',
      text: 'An email will be sent to you confirming that your pending request has been canceled.',
    },
    Stop_Requested: {
      buttonText: 'Return to Payments',
      header: 'Good news! Your request to unenroll from automatic payments has been canceled',
      text: 'An email will be sent to you confirming that your pending request has been canceled. You will remain enrolled in automatic payments.',
    },
  },
  error: {
    buttonText: 'Return to Payments',
    header: 'Autopay Unenrollment Unsuccessful',
    text: 'Please try again or call customer service.',
  },
  stop: {
    buttonText: 'Cancel Request to Unenroll from Automatic Payments',
    header: 'Good news! We received your request to unenroll from automatic payments',
    iconName: 'registerRobot',
    modalToOpen: 'cancel',
    text: 'Your request will be processed. An email will be sent to you confirming that we have received your request.',
  },
};

export const CONFIRMATION_DICTIONARY_AUTOPAY = {
  cancel: {
    animationName: 'robot',
    labelArray: [{ key: 'confirmationNumber', label: 'Confirmation Details' }],
    successHeader: 'Request Confirmation',
    successLinkLabel: 'Make Another Payment',
    successSubHeader: 'Good news! Your autopay enrollment has been canceled',
    successText: 'Please make your next payment on time or within the grace period to avoid late fees.',
  },
  change: {
    animationName: 'flyingMoney',
    labelArray: [
      { key: 'confirmationNumber', label: 'Confirmation Details' },
      { key: 'totalPayment', label: 'Payment Amount' },
      { key: 'paymentSource', label: 'Payment Source' },
      { key: 'beginDate', label: 'Start Date' },
      { key: 'delayDays', label: 'Delay Payment' },
    ],
    modalToOpen: 'cancel',
    successHeader: 'Request Confirmation',
    successLinkLabel: 'Cancel Request',
    successSubHeader: 'Good news! We received your request to update your automatic payment settings',
    successText: 'Your request will be processed. An email will be sent to you confirming that we have received your request.',
  },
  enable: {
    animationName: 'flyingMoney',
    labelArray: [
      { key: 'confirmationNumber', label: 'Confirmation Details' },
      { key: 'totalPayment', label: 'Payment Amount' },
      { key: 'beginDate', label: 'Start Date' },
      { key: 'delayDays', label: 'Delay Payment' },
    ],
    modalToOpen: 'cancel',
    successHeader: 'Request Confirmation',
    successLinkLabel: 'Cancel Request',
    successSubHeader: 'Good news! We received your request to enroll for automatic payments',
    successText: 'Your request will be processed. An email will be sent to you confirming that we have received your request.',
  },
  shared: {
    errorHeader: 'Autopay Error',
    errorLinkLabel: 'Back to Payments',
    errorSubHeader: 'There was a problem with your request',
    errorText: 'Please try again or call customer service.',
  },
  stop: {
    animationName: 'flyingMoney',
    labelArray: [{ key: 'confirmationNumber', label: 'Confirmation Details' }],
    successHeader: 'Request Confirmation',
    successLinkLabel: 'Cancel Request to Unenroll From Automatic Payments',
    successSubHeader: 'Good news! We received your request to unenroll from automatic payments',
    successText: 'Your request will be processed. An email will be sent to you confirming that we have received your request.',
  },
};

export const DEFAULT_AUTOPAY_ENABLE_ERRORS = {
  accountNumber: '',
  accountNumberConfirm: '',
  accountType: '',
  additionalPrincipal: '',
  bannerError: false,
  beginDate: '',
  delayDays: '',
  nameOnAccount: '',
  routingNumber: '',
  sourcesBannerError: false,
};

export const FULL_ERROR_REASON_CODES = ['9004.1000', '9004.1001', '9004.1002', '9004.1004'];

export const INFO_COPY_DICT = {
  confirmation: {
    change: [{
      iconAlignSelf: 'flex-start',
      text: INTL_IDS.INFOCOPY_CONFIRMATION_CHANGE_IFYOUHAVEQUESTIONS,
      variant: 'warning',
    }],
    enable: [
      {
        iconAlignSelf: 'flex-start',
        text: INTL_IDS.INFOCOPY_CONFIRMATION_ENABLE_IFYOURPAYMENT,
        variant: 'warning',
      },
      {
        iconAlignSelf: 'flex-start',
        text: INTL_IDS.INFOCOPY_CONFIRMATION_ENABLE_YOURFIRSTDRAFT,
        variant: 'pending',
      },
      {
        text: INTL_IDS.INFOCOPY_CONFIRMATION_ENABLE_IFYOURDRAFTDATE,
        variant: 'pending',
      },
      {
        text: INTL_IDS.INFOCOPY_CONFIRMATION_ENABLE_IFYOUHAVEQUESTIONS,
        variant: 'info',
      },
    ],
    stop: [
      {
        iconAlignSelf: 'flex-start',
        text: INTL_IDS.INFOCOPY_CONFIRMATION_STOP_IFYOUHAVEQUESTIONS,
        variant: 'warning',
      },
      {
        iconAlignSelf: 'flex-start',
        text: INTL_IDS.INFOCOPY_CONFIRMATION_STOP_RESPONSIBILITY,
        variant: 'warning',
      },
    ],
  },
  review: [
    {
      text: INTL_IDS.INFOCOPY_REVIEW_IFYOUHAVEQUESTIONS,
      variant: 'pending',
    },
  ],
  setup: [
    {
      text: INTL_IDS.INFOCOPY_SETUP_CUTOFFTIME,
      variant: 'pending',
    },
    {
      text: INTL_IDS.INFOCOPY_SETUP_IFYOURNEXTAUTOMATICPAYMENT,
      variant: 'warning',
    },
  ],
};

export const REASON_CODE_DICTIONARY = {
  9004.1005: {
    key: 'routingNumber',
    message: 'Routing number is required',
    screen: 'AutopaySource',
  },
  9004.1006: {
    key: 'routingNumber',
    message: 'Routing number is invalid',
    screen: 'AutopaySource',
  },
  9004.1007: {
    key: 'accountNumber',
    message: 'Account number is required',
    screen: 'AutopaySource',
  },
  9004.1008: {
    key: 'accountNumber',
    message: 'Account number is invalid',
    screen: 'AutopaySource',
  },
  9004.1009: {
    key: 'nameOnAccount',
    message: 'Name on account is required',
    screen: 'AutopaySource',
  },
  '9004.1010': {
    key: 'nameOnAccount',
    message: 'At least one alpha character is required for the account name field. Punctuation including periods and commas are not allowed in the account name field',
    screen: 'AutopaySource',
  },
  9004.1011: {
    key: 'additionalPrincipal',
    message: 'Additional principal amount has to be greater than or equal to zero',
    screen: 'AutopayAmount',
  },
  9004.1012: {
    key: 'additionalPrincipal',
    message: 'Additional principal must be less than or equal to the max allowed additional principal',
    screen: 'AutopayAmount',
  },
  9004.1013: {
    key: 'beginDate',
    message: 'Autopay Begin Date is required',
  },
  9004.1014: {
    key: 'beginDate',
    message: 'Autopay Begin Date is invalid',
  },
  9004.1015: {
    key: 'delayDays',
    message: 'Autopay Delay Day setting is required',
  },
  9004.1016: {
    key: 'delayDays',
    message: 'Autopay Delay Day setting is invalid',
  },
  9004.1017: {
    key: 'sourcesBannerError',
    message: 'Unable to use existing account information. Please provide your account information again.',
    screen: 'AutopaySource',
  },
};

export const EMAIL_TOOLTIP_COPY = 'Yes, I would like to receive email notifications when payments post to my account.';

export const REVIEW_DICTIONARY_AUTOPAY = {
  // Added empty strings to prevent application from breaking on native - props are required within PaymentModal.
  cancel: {
    headerTitle: '',
    heading: '',
    paragraphText: '',
  },
  change: {
    headerTitle: 'Review Request',
    heading: 'Please review the requested updates to your automatic payment settings',
    paragraphText: 'Please note that if this request is submitted less than 10 days prior to your next scheduled draft date, then the change(s) may not take effect with your next scheduled draft date.',
  },
  enable: {
    headerTitle: 'Review Request',
    heading: 'Please review your details',
    paragraphText: 'Autopay will take effect with the <b>{{date}}</b> payment.',
  },
};

export const SCHEDULE_AUTOPAY_DICTIONARY = {
  cancel: { headerText: '', summaryButtonLabel: '' },
  change: { headerText: 'Edit Autopay', summaryButtonLabel: 'Update Autopay' },
  enable: { headerText: 'Set Up Autopay', summaryButtonLabel: 'Review Autopay' },
};

export const TOOLTIP_PROPS = {
  additionalPrincipal: {
    content: INTL_IDS.TOOLTIP_ADDITIONALPRINCIPAL_CONTENT,
    linkText: INTL_IDS.TOOLTIP_LINKTEXT,
    title: INTL_IDS.TOOLTIP_ADDITIONALPRINCIPAL_TITLE,
  },
  delayDays: {
    content: INTL_IDS.TOOLTIP_DELAYDAYS_CONTENT,
    linkText: INTL_IDS.TOOLTIP_LINKTEXT,
    title: INTL_IDS.TOOLTIP_DELAYDAYS_TITLE,
  },
  regularMonthlyPayment: {
    content: INTL_IDS.TOOLTIP_REGULARMONTHLYPAYMENT_CONTENT,
    linkText: INTL_IDS.TOOLTIP_LINKTEXT,
    title: INTL_IDS.TOOLTIP_REGULARMONTHLYPAYMENT_TITLE,
  },
};

export const EMAIL_ERROR_BANNER_TEXT = 'We were unable to send email confirmation. Please update your email preferences in the settings at a later time.';

export const MANCODE_Y_TEXT = '<b>Ineligible to enroll in Autopay.</b>\nFor additional information, please call customer service at <a>1-877-330-4051</a>.';

export const PAYMENT_FLOW_TYPE_AUTOPAY = 'autopay';
